var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"my-6"},_vm._l((_vm.formInputs),function(input,inputIndex){return _c('StepConfigurationItem',{key:("input-" + inputIndex),attrs:{"inputs":_vm.form.inputs,"selectedValue":_vm.selectedValue,"stepIndex":_vm.stepIndex,"title":_vm.title},on:{"select-step":_vm.gotToStep}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34303235","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHabiteoStudio/steps/components/StepConfiguration.vue
// module id = null
// module chunks = 